import audiomessagesicon from "../otherImg/audiomsgsimg.jpg";
import { Link } from "react-router-dom";

 const AudioListContent = ({audioID,audioTitle}) => {

    const shareAudio=async()=>{
        if(navigator.share){
            try{
                await navigator.share({
                    title: `${audioTitle}`,
                    text: `Listen to this message and your life will never be the same. Very inspiring and crucial for our eternal life.`,
                    url: `https://horemowbookreaderlite.web.app/hrmwaudiomessage/${audioTitle}/${audioID}`,
                });
            }catch{
                
            }
        }
    };



    return ( 
        <div className="audiomsgcontainer"  key={audioID}>
        <Link className="audioMessageContent" to={`/hrmwaudiomessage/${audioTitle}/${audioID}`}>
            <h3>Audio {audioID}</h3>
            <pre style={{color:"orangered"}}>{audioTitle}</pre>
            <img src={audiomessagesicon} alt="book Cover" />

        </Link>
        <Link className="audioMessageContent2" to={`/hrmwaudiomessage/${audioTitle}/${audioID}`}>
            <h3>{audioID}</h3>
            <pre style={{color:"orangered"}}>{audioTitle}</pre>
            <img src={audiomessagesicon} alt="book Cover" />

        </Link>
        <svg
            onClick={()=>shareAudio()}
                viewBox="0 0 24 24"
                fill="currentColor"
                height="2em"
                width="2em">
                <path d="M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 006 9c-1.654 0-3 1.346-3 3z" />
            </svg>
           
        </div>
     );
}
export default AudioListContent;